export default "__VITE_ASSET__07x5AUtU__"